import React, { useState, useEffect } from 'react';
import { CustomTable, ModalComponent } from '../../../../components';
import {
  getRefundDetailsByBookingIdService,
  Columns,
} from '../../../../services/index.service';
import i18next from 'i18next';

export default function RefundDeductionDetailModal({ show, onCancel, data }) {
  const [loading, setLoading] = useState(false);
  const [refundData, setRefundData] = useState([]);
  const [page, setPage] = useState({
    currentPage: 1,
    sizePerPage: 10,
  });
  const { currentPage, sizePerPage } = page;

  useEffect(() => {
    if (show && data) {
      if (data?.bookingId) {
        fetchRefundDetails();
      } else {
        setRefundData([data]);
      }
    } else {
      setRefundData([]);
    }
  }, [show, data]);

  const fetchRefundDetails = async () => {
    setLoading(true);
    try {
      const response = await getRefundDetailsByBookingIdService(
        data?.bookingId,
        data?.id
      );
      if (response?.success && response?.data) {
        const list = Array.isArray(response.data)
          ? response.data
          : [response.data];
        setRefundData(list.length > 0 ? list : [data]);
      } else {
        setRefundData(data ? [data] : []);
      }
    } catch (e) {
      setRefundData(data ? [data] : []);
    } finally {
      setLoading(false);
    }
  };

  const currentPaymentType = (
    refundData?.[0]?.paymentType ||
    data?.paymentType ||
    ''
  ).toLowerCase();

  const columns = Columns.refundAndDeductionDetailTableColumn({
    page: currentPage,
    sizePerPage,
    paymentType: currentPaymentType,
  });

  return (
    <ModalComponent
      backdrop
      show={show}
      onHandleCancel={onCancel}
      title={i18next.t('text.report.refundDetailsTitle')}
      extraClassName="modal-xxl"
      modalExtraClass="refund-details-wide"
    >
      <div
        style={{
          overflowX: 'auto',
          WebkitOverflowScrolling: 'touch',
          paddingBottom: '20px',
        }}
      >
        <CustomTable
          tableData={refundData}
          searchDisabled={true}
          tableColumns={columns}
          count={refundData?.length || 0}
          setSearchData={() => {}}
          setPage={setPage}
          sizePerPage={sizePerPage}
          currentPage={currentPage}
          pagination={false}
          header={false}
          isModalPadding={true}
          tableLoader={loading}
        />
      </div>
    </ModalComponent>
  );
}
